import { render } from "./Daftar.vue?vue&type=template&id=1c1397b6"
import script from "./Daftar.vue?vue&type=script&lang=js"
export * from "./Daftar.vue?vue&type=script&lang=js"

import "./Daftar.vue?vue&type=style&index=0&id=1c1397b6&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__